const RentalRoutes = {
  Rentals: '/rentals',
  RentalDetails: '/rentals/:rentalId',
  CancelShowing: '/showings/:showingId/cancel-showing',
  ProspectPage: '/showings/:showingUuid',
};

export const AppRoutes = {
  root: '/rentals',
  Auth: '/auth',
  ...RentalRoutes,
};
